import { Cart } from "@insite/client-framework/Services/CartService";
import { BillToModel, CartModel, ProductModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// get global for google tag manager
function getDataLayer() {
    if (typeof window !== "undefined") {
        return (window as any).dataLayer || [];
    }
}

export function ViewItem(item: ProductModel | undefined) {
    const dataLayer = getDataLayer();

    if (dataLayer) {
        dataLayer.push({
            event: "view_item",
            value: "",
            itemNumber: item?.productNumber,
            google_business_vertical: "retail",
        });
    }
}

export function AddToCart(item: any, quantity: number) {
    const dataLayer = getDataLayer();

    if (dataLayer) {
        dataLayer.push({
            event: "add_to_cart",
            value: item.unitListPrice,
            quantity,
            item: item.productNumber,
            google_business_vertical: "retail",
        });
    }
}

export function ViewCart(cart: Cart) {
    const dataLayer = getDataLayer();

    const items = getItems(cart);

    if (dataLayer) {
        dataLayer.push({
            event: "view_cart",
            value: cart.orderSubTotal,
            items,
        });
    }
}

export function ViewCheckout(cart: Cart, billTo: BillToModel | undefined) {
    const dataLayer = getDataLayer();

    const items = getItems(cart);

    if (dataLayer) {
        dataLayer.push({
            event: "checkout",
            value: cart.orderSubTotal,
            phone: billTo?.phone || "",
            email: billTo?.email || "",
            state: billTo?.state?.name,
            items,
        });
    }
}

export function Purchase(cart: Cart, shipTo: ShipToModel | undefined) {
    const dataLayer = getDataLayer();

    const items = getItems(cart);

    if (dataLayer) {
        dataLayer.push({
            event: "purchase",
            orderNumber: cart.orderNumber,
            orderTotal: cart.orderGrandTotal,
            shippingAmount: cart.shippingAndHandling,
            shippingService: cart.shipVia?.description,
            shippingState: shipTo?.state?.name,
            promotions: cart.promotionCode,
            items,
        });
    }
}

function getItems(cart: CartModel) {
    const items = [] as any;
    cart.cartLines?.forEach(line => {
        items.push({ id: line.productName, google_business_vertical: "retail", quantity: line.qtyOrdered });
    });

    return items;
}
